import { render, staticRenderFns } from "./Pivot.vue?vue&type=template&id=52e811f6&"
import script from "./Pivot.vue?vue&type=script&lang=js&"
export * from "./Pivot.vue?vue&type=script&lang=js&"
import style0 from "./Pivot.vue?vue&type=style&index=0&id=52e811f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports